import React from 'react';
import styled from 'styled-components';
import * as Ant from 'antd';
import * as AppActions from '../../../AppActions';
import {zip3} from 'rev.sdk.js/Constants/taiwan';

const districts = zip3.filter((x) => x.city === '臺北市');

export default function ClinicSearch(props) {
  const [district, setDistrict] = React.useState('');
  const [name, setName] = React.useState('');

  return (
    <Wrapper>
      <div className="header">
        <h2>診所查詢</h2>
      </div>

      <ul>
        <li>查詢條件可交叉查詢。</li>
        <li>查詢地區為台北市。</li>
      </ul>
      <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
        <div>台北市</div>
        <Ant.Select
          value={district}
          onSelect={(value) => {
            setDistrict(value);
          }}
          style={{marginLeft: 5}}>
          <Ant.Select.Option value={''}>全區</Ant.Select.Option>
          {districts.map((x) => (
            <Ant.Select.Option key={x.district} value={x.district}>
              {x.district}
            </Ant.Select.Option>
          ))}
        </Ant.Select>
      </div>
      <Ant.Input
        value={name}
        onChange={(e) => {
          const value = e.target.value;
          setName(value);
        }}
        placeholder="診所名稱"
        style={{marginBottom: 20}}
      />
      <Ant.Button
        type="primary"
        block
        size="large"
        onClick={() => {
          AppActions.navigate(
            `/people/hospital/?name=${name}&district=${district}`,
          );
        }}>
        查詢
      </Ant.Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;

  .header {
    display: flex;
    align-items: center;

    & > h2 {
      border-bottom-width: 2px;
      border-bottom-style: solid;
      border-bottom-color: var(--primaryColor);
      padding-bottom: 5px;
    }
  }

  & > ul {
    margin: 20px 0;
    & > li {
      margin-bottom: 10px;
    }
  }
`;
